var utils = {}
utils.RegExp = {
  MobileReg: /^1\d{10}$/, //手机号11位数
  EmailReg: /^(\w-*\.*)+@(\w-?)+(\.\w{2,})+$/, //电子邮箱
  PwdReg: /^[0-9]{8,16}$/, //密码8-16位数
  InvoiceReg: /^[\u4e00-\u9fa5]{0,50}$/, //发票0-50位
  TaxNumReg: /^[A-Za-z0-9]{0,50}$/, //税号0-50位
  NumberReg: /^[0-9]*$/, //数字匹配
}
export default utils



// WEBPACK FOOTER //
// ./src/utils/RegExp.js